import React from 'react';

import Select from './Inputs/Select/Select';
import Textarea from './Inputs/Textarea/Textarea';
import TextInput from './Inputs/TextInput/TextInput';
import EmailInput from './Inputs/EmailInput/EmailInput';
import Honeypot from './Inputs/Honeypot/Honeypot';

import * as styles from './FormField.module.scss';

interface props {
    children: React.ReactNode,
    label: string,
    id: string,
    optional?: boolean,
}

const FormField = ({ id, label, children, optional = false }: props): JSX.Element => {
    return (
        <div className={styles.FormField}>
            <label htmlFor={id} className={`note ${styles.FormFieldLabel}`}>{label} {(optional) ? <span className="text-velvet">(optional)</span> : null}</label>
            {children}
        </div>
    );
};

FormField.Honeypot = Honeypot;
FormField.Select = Select;
FormField.TextInput = TextInput;
FormField.Email = EmailInput;
FormField.Textarea = Textarea;

export default FormField;
